import {
  ForecastChangeRecords,
  ForecastChangeRecordsModel
} from "components/project/forecasts/ForecastChangeRecords";

function TypeWellEditorChangeRecords({ forecastId }: ForecastChangeRecordsModel) {
  return <ForecastChangeRecords forecastId={forecastId} />;
}

export default TypeWellEditorChangeRecords;
